
import img1 from '../images/icon/icon1.png'
import img2 from '../images/icon/icon2.png'
import img3 from '../images/icon/icon3.png'
import img4 from '../images/icon/icon4.png'

const dataBox = [

    {
        id: 1,
        img: img1,
        title: 'Multi-Chain Trading',
        desc: 'Supports various blockchain networks, expanding trading opportunities'
    },
    {
        id: 2,
        img: img2,
        title: 'Advanced Trading Tools',
        desc: 'Snipe and Copy Trades for faster trading'
    },
    {
        id: 3,
        img: img3,
        title: 'Multi-Wallet Support',
        desc: 'Manage multiple wallets simultaneously for convenience'
    },
    {
        id: 4,
        img: img4,
        title: 'Real-Time Market Data',
        desc: 'Access up-to-date market information to make informed decisions'
    },

]

export default dataBox;